import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingValueModel } from 'src/app/models/api/setting-value.model';
import { WorkflowListItem } from 'src/app/models/workflowlistitem';
import { CachedSettingsApiClient } from 'src/app/services/api-clients/cached-settings.apiclient';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LoggingService } from 'src/app/services/logging.service';
import { WorkFlowTypeEnum, WorkflowService } from 'src/app/services/workflow.service';

@Component({
    selector: 'app-new-request-picker',
    templateUrl: './new-request-picker.component.html'
})
export class NewRequestPickerComponent implements OnInit, OnDestroy {
    private subscription;
    workflows: WorkflowListItem[] = [];
    organisationGuid!: string;
    allowAllRequestsTypes: boolean = true;

    get workflowsOfTypeGeneric(): WorkflowListItem[] {
        return this.workflows.filter(x => x.workflowType == WorkFlowTypeEnum.Generic);
    }
    get workflowsOfTypeTax(): WorkflowListItem[] {
        return this.workflows.filter(x => x.workflowType == WorkFlowTypeEnum.Tax);
    }
    get workflowsOfTypeChamberOfCommerce(): WorkflowListItem[] {
        return this.workflows.filter(x => x.workflowType == WorkFlowTypeEnum.ChamberOfCommerce);
    }
    get workflowsOfTypeSbrNexus(): WorkflowListItem[] {
        return this.workflows.filter(x => x.workflowType == WorkFlowTypeEnum.SbrNexus);
    }
    get workflowsOfTypeWwft(): WorkflowListItem[] {
        return this.workflows.filter(x => x.workflowType == WorkFlowTypeEnum.Wwft);
    }

    constructor(private router: Router, private loggingService: LoggingService,
        private workflowService: WorkflowService, private authenticationService: AuthenticationService, private cachedSettingsApiClient: CachedSettingsApiClient) {

        this.subscription = this.authenticationService.currentUser.subscribe({
            next: (currentUserData: any) => {
                this.cachedSettingsApiClient.getWorkflowSettings(currentUserData.organisationGuid).subscribe((workflowSettings: SettingValueModel[]) => {
                    this.workflowService.getWorkflowList()
                        .then(values => {
                            this.workflows = values;
                            if (workflowSettings.length > 0) {
                                workflowSettings.forEach(workflowSetting => {
                                    let workflowIndex = this.workflows.findIndex(wf => wf.bySettingName.toLocaleLowerCase() === workflowSetting.name.toLocaleLowerCase());
                                    if (!workflowSetting.isEnabled && workflowIndex > -1) {
                                        this.workflows.splice(workflowIndex, 1);
                                    }
                                });
                            }
                        })
                        .catch(error => this.loggingService.logException(error));
                });
            },
            error: (error: any) => {
                this.loggingService.logException(error);
            }
        });
    }
    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.workflowService.getWorkflowList()
            .then(values => this.workflows = values)
            .catch(error => this.loggingService.logException(error));
    }

    openNewRequest(workflowId: string) {
        this.router.navigate(["/build"], { queryParams: { workflowId: workflowId } })
            .catch(error => {
                this.loggingService.logException(error);
            });
    }

}
